import IpsAlert from './IpsAlert.vue';
import '../../../styles/custom.scss';

export default IpsAlert;
